export default {
  related: {
    title: 'Relacionados',
    theRelatedListCouldNotBeLoaded: 'A lista de relacionados não pode ser carregada'
  }
}
